import Countdown from 'react-countdown';
import style from './Main.module.css';
import React, { useRef, useEffect, useState } from "react";

import logo_cn from "../source/hand-draw-wedding-chinese-style-full-invitation.png"
import logo_en from "../source/hand-draw-wedding-western-style-full-invitation.png"
import thank from "../source/thank.jpg"
import thanken from "../source/thank-en.jpg"
import chinese_bg from "../source/chinese-bg.png"
import western_bg from "../source/western-bg.png"
import both from "../source/both.jpg"
import bothen from "../source/both-en.jpg"

import translate from "../source/lang.json"

const preloadSrcList = [ logo_cn, logo_en, chinese_bg, western_bg, thank, thanken ]

const actual_date = "2023-06-13 8:00 pm";
const dinner_date = "2023-06-17 6:00 pm";

const loadCN = () => {
    let l = "CN"
    translate[l].both = both
    translate[l].logo = logo_cn
    translate[l].thank = thank
    translate[l].bg = chinese_bg
}

const loadEN = () => {
    let l = "EN"
    translate[l].both = bothen
    translate[l].logo = logo_en
    translate[l].thank = thanken
    translate[l].bg = western_bg
}

const callback = (entries, observer) => {
  entries.forEach(entry => {
    const target = entry.target.firstChild;
    // console.log('entry.intersectionRatio',entry.intersectionRatio)
    if(entry.intersectionRatio >= 0.75){
        // console.log('set Visible')
        target.classList.add(style.isVisible);
    }else{
        // console.log('remove Visible')
        target.classList.remove(style.isVisible);
    }
  });
}
const preloadImage = src => {
    return new Promise( (resolve, reject) => {
        const img = new Image()
        img.onload = () => { resolve(img) }
        img.onerror = () => { reject(src) }
        img.src = src
    })
}




export default function Invite() {
    const langRef = useRef([])
    const sectionRef = useRef([])
    const loadingRef = useRef()
    const welcomeRef = useRef()
    const [lang, setLang] = useState('CN')
    const [responseBody, setResponseBody] = useState({id:null, name: "", mobile: "", count: ""})
    const [loadLocal, setLoadLocal] = useState(false)

    loadCN();

    const changeLanguage = () => {
        if(lang === 'CN'){
            setLang('EN')
            loadEN()
            langRef.current.innerHTML = "CN"
        }else{
            setLang('CN')
            loadCN()
            langRef.current.innerHTML = "EN"
        }
    }
    const renderer = ({ days, hours, minutes, seconds, completed }) => {
        if (completed) {
            // Render a completed state
            return <content>This is the day</content>
        } else {
            // Render a countdown
            return (
                <div className={style.countdown_time}>
                    <group> <value>{days}</value> <unit>{translate[lang].day}</unit> </group>
                    <group> <value>{hours}</value> <unit>{translate[lang].hour}</unit> </group>
                    <group> <value>{minutes}</value> <unit>{translate[lang].min}</unit> </group>
                    <group> <value>{seconds}</value> <unit>{translate[lang].sec}</unit> </group>
                </div>
            );
        }
    };

    useEffect(()=>{
        const observer = new IntersectionObserver(callback,{rootMargin:'0px', threshold: 0.75});
        // console.log("load sectionRef",sectionRef)
        sectionRef.current.forEach(section => {
            // console.log("load section",section)
            if(section != null) observer.observe(section);
        })

        if (localStorage.getItem("wed-reg") !== null && !loadLocal) {
            let temp = JSON.parse(localStorage.getItem('wed-reg'));
            // console.log('temp',temp);
            if (temp && temp.id !== undefined && temp.id !== null && temp.id !== "") { 
                setResponseBody(temp)
                // console.log('responseBody',responseBody);
                welcomeRef.current.classList.remove(style.hide);
            }else{
                welcomeRef.current.classList.add(style.hide);
            }
            setLoadLocal(true)
        }
    },[loadLocal])

    useEffect(()=>{
        const effect = async () => {
            const imagesPromiseList = []
            for(const i of preloadSrcList){
                imagesPromiseList.push(preloadImage(i))
            }
            await Promise.all(imagesPromiseList)
            loadingRef.current.style = "display:none"
        }
        effect()
    })

    const this_style = {
        bg: {
            backgroundColor: '#fff',
            backgroundRepeat: 'no-repeat',
            backgroundPositionX:'right',
            backgroundPositionY: 'center',
            backgroundsize: '600px',
            backgroundImage: `url(${translate[lang].bg})`
        }
    }
    
    return (
        <>
        <button className={style.float_language} ref={langRef} onClick={changeLanguage}>EN</button>
        <div className={style.main}>
            {/* <div className={style.load_section} ref={(element) => {sectionRef.current.push(element); loadingRef.current = element;}}>
                <div className={style.container}>
                    <img src={loading} alt=""></img>
                </div>
            </div> */}

            <div className={style.section} ref={(element) => sectionRef.current.push(element)}>
                <div className={style.container}>
                    <img src={translate[lang].logo} width="80%" alt=""></img>
                </div>
            </div>

            <div className={style.section} ref={(element) => {sectionRef.current.push(element); welcomeRef.current = element}}>
                <div className={`${style.container}`}  style={this_style.bg} >
                    <img src={translate[lang].thank} width="60%" alt=""></img>
                    <content>{translate[lang].word_welcome}{responseBody.name},</content>
                    <content>{translate[lang].thank_welcome}</content>
                </div>
            </div>

            <div className={style.section} ref={(element) => sectionRef.current.push(element)}>
                <div className={`${style.container}`}  style={this_style.bg} >
                    <header>{translate[lang].actual_day}</header>
                    <content>{translate[lang].date} : {actual_date}</content>
                    <content><Countdown date={actual_date} renderer={renderer} /></content>
                </div>
            </div>

            <div className={style.section} ref={(element) => sectionRef.current.push(element)}>
                <div className={`${style.container}`}  style={this_style.bg} >
                    <header>{translate[lang].dinner_day}</header>
                    <content>{translate[lang].date} : {dinner_date}</content>
                    <content><Countdown date={dinner_date} renderer={renderer} /></content>
                </div>
            </div>

        </div>
        </>
    );
};
